export class DOM {
    constructor(doc) {
        this._document = doc ? doc : document;
    }
    get document() {
        return this._document;
    }
    createElement(tagName, className, container) {
        const element = this._document.createElement(tagName);
        if (className) {
            element.className = className;
        }
        if (container) {
            container.appendChild(element);
        }
        return element;
    }
}
//# sourceMappingURL=DOM.js.map